module.exports = __webpack_public_path__ + "staticcomp/img/cover.0f0f153.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/16/cover.jpg
// module id = PIWd
// module chunks = 39